import React, { useCallback } from 'react';
import { Grid, Paper } from '@mui/material';
import PropTypes from 'prop-types';
import { CommandPanels, EditorControls, withBaseEditor } from '../../BaseEditor';

function EditorRenderer({
  getControl, currentUser, dataSetter, data,
}) {
  const getNestedValue = useCallback((param, v = '') => {
    // eslint-disable-next-line no-constant-condition
    const initData = {
      region_ext: {
        name_chief: '',
        name_spec: '',
        org_name: '',
        org_adress: '',
      },
    } ? ((data.region_ext === undefined) || (data.region_ext === null)) : data.region_ext;

    return ({
      region_ext: {
        ...initData,
        [param]:
        v,
      }
      ,
    });
  }, [data.region_ext]);

  const getValue = useCallback((name) => {
    if ((data.region_ext === undefined) || (data.region_ext === null)) {
      return '';
    } return data.region_ext[name];
  }, [data.region_ext]);

  return (
    <>
      <Paper>
        <Grid container>
          <Grid item sm={2}>
            {getControl('code')}
          </Grid>
          <Grid item sm={10}>
            {getControl('name')}
          </Grid>
          {currentUser.is_superuser && (
          <Grid item sm={12}>
            {getControl('org', {
              backend: '/api/catalog/orgs/',
            })}
          </Grid>
          )}
        </Grid>
      </Paper>
      <Paper>
        <Grid container>
          <Grid item sm={6}>
            <EditorControls.TextInput
              label="ПІБ начальника (Голови)"
              canErase
              value={getValue('name_chief')}
              onChange={(e, v) => dataSetter(getNestedValue('name_chief', v))}
            />
          </Grid>
          <Grid item sm={6}>
            <EditorControls.TextInput
              label="ПІБ Паспортиста"
              canErase
              value={getValue('name_spec')}
              onChange={(e, v) => dataSetter(getNestedValue('name_spec', v))}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item sm={6}>
            <EditorControls.TextInput
              label="Назва підприємства/організації, виконавчого органу"
              canErase
              value={getValue('org_name')}
              onChange={(e, v) => dataSetter(getNestedValue('org_name', v))}
            />
          </Grid>
          <Grid item sm={6}>
            <EditorControls.TextInput
              label="Адреса підприємства/організації, виконавчого органу"
              canErase
              value={getValue('org_adress')}
              onChange={(e, v) => dataSetter(getNestedValue('org_adress', v))}
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}

EditorRenderer.propTypes = {
  getControl: PropTypes.func.isRequired,
  data: PropTypes.shape({
    region_ext: {
      name_chief: '',
      name_spec: '',
      org_name: '',
      org_adress: '',
    },
  }).isRequired,
  dataSetter: PropTypes.func.isRequired,
  currentUser: PropTypes.shape().isRequired,
};
export default withBaseEditor(EditorRenderer, '/api/catalog/regions/', CommandPanels.catCommandPanel);
